import { ADMIN_API_BASE_URL } from '../config/api';

async function request(path, { method = 'GET', body, signal } = {}) {
  const token = localStorage.getItem('authToken');
  if (!token)
    throw new Error('Please log in again to manage external partners.');

  const response = await fetch(`${ADMIN_API_BASE_URL}/enterprise${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    cache: 'no-store',
    signal,
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const result = await response.json().catch(() => null);
  if (response.status === 401) {
    throw new Error(
      'Your admin session has expired. Please log out and log in again.',
    );
  }
  if (response.status === 403) {
    throw new Error('You need admin access to manage external partners.');
  }
  if (!response.ok || !result?.success) {
    throw new Error(
      result?.message || 'Unable to complete the request. Please try again.',
    );
  }
  return result.data;
}

export function listExtPartnerUsers({
  query = '',
  page = 1,
  limit = 25,
  signal,
} = {}) {
  const params = new URLSearchParams({
    query,
    page: String(page),
    limit: String(limit),
  });
  return request(`/users?${params}`, { signal });
}

export function createExtPartner({
  partnerName,
  name,
  email,
  password,
  units,
}) {
  return request('/partners', {
    method: 'POST',
    body: { partnerName, name, email, password, units },
  });
}

export function updateExtPartnerPassword(userId, password) {
  return request(`/users/${encodeURIComponent(userId)}/password`, {
    method: 'PATCH',
    body: { password },
  });
}
